export default {
  title: 'Add users to: {0}',

  addUsersButton: 'Add users',
  addUsersLoadingButton: 'Adds users...',

  successToast: 'Users are added'
}